<template>
    <v-main v-on:drop.prevent class="mx-xl-12 px-xl-12 mx-md-5 px-md-5 mx-sm-2 px-sm-2 my-0 py-0"
               style="">
        <v-layout row class="mt-10">
            <v-flex md12 sm12>
                <div class="ml-6">
                    <div class="text-center text__colour-teal text__size-32 text__style-bold">Edit your direct mail template</div>
                    <div class="text-center text__colour-grey text__size-18 text__style-bold layout__margin__bottom-20">Click directly into the template to edit</div>

                    <v-sheet class="mx-auto text__align-center">
                        <main class="main">
                            <div class="main__section main__section-iframe">
                                <div class="main__iframe">
                                    <iframe id="editorFrame"></iframe>
                                </div>
                            </div>
                        </main>

                        <div class="margin-top-10 layout__display-none" id="pageNavigation">
                            <v-icon id="cmdFirst" :class="cmdFirst_class" @click="clickFirst()">mdi-skip-previous
                            </v-icon>
                            <v-icon id="cmdPrev" :class="cmdPrev_class" @click="clickPrev()">mdi-chevron-left
                            </v-icon>
                            <div class="pageNumber" name="pageNumber" id="pageNumber">{{ pageNumber }}</div>
                            <v-icon id="cmdNext" :class="cmdNext_class" @click="clickNext()">mdi-chevron-right
                            </v-icon>
                            <v-icon id="cmdLast" :class="cmdLast_class" @click="clickLast()">mdi-skip-next</v-icon>
                        </div>
                    </v-sheet>

                    <v-layout row py-10>
                        <v-flex md6 class="text-left">
                            <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer layout__float-left"
                                    v-on:click="showSaveTemplateDialog('back')">Back
                            </el-button>
                        </v-flex>

                        <v-flex md6 class="text-right">
                            <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer"
                                    v-on:click="gotoStep('personalise-design-advanced')">Advanced edit
                            </el-button>

                            <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer"
                                    v-on:click="showSaveTemplateDialog('save')">Save
                            </el-button>

                            <el-button class="button__base layout__width-200px button__background-red layout__cursor-pointer"
                                    v-on:click="gotoStep('preview-design')">Continue
                            </el-button>
                        </v-flex>

                        <v-snackbar v-model="saveTemplateSuccess" color="success" :top="true" :timeout="5000">
                            Your template has been saved successfully.
                            <v-btn text @click="saveTemplateSuccess = false">
                                Close
                            </v-btn>
                        </v-snackbar>

                        <v-snackbar v-model="saveTemplateFailure" color="error" :top="true" :timeout="5000">
                            Sorry there has been a problem saving your template. Please try again.
                            <v-btn text @click="saveTemplateFailure = false">
                                Close
                            </v-btn>
                        </v-snackbar>

                    </v-layout>

                    <div class="layout__position-relative layout__padding__bottom-20px">
                        <div class="display-inline-block">
                            <i class="layout__position-absolute layout__top-4px el-icon-info text__colour-red text__size-20"></i>
                        </div>
                        <div class="display-inline-block layout__margin__left-30 text__size-16">
                            Need some further support?<br>
                            Visit our Knowledge Centre which is full of "how to" videos and<br>
                            guides to help guide you through the process, click <a href="https://ravensworthprinted.zendesk.com/hc/en-us" target="new" class="here-link">here</a>.
                        </div>
                    </div>

                    <div class="layout__padding-clear" v-show="showSaveTemplate">
                        <el-dialog
                                :visible.sync="showSaveTemplate"
                                :show-close=false
                                width="500px"
                                top="25vh">
                            <div class="text__size-22 text__align-center layout__margin__bottom-20">Save Template</div>
                                
                            <div class="text__align-center">
                                <v-text-field
                                    class="layout__margin__left-20 layout__margin__right-20"
                                    ref="filename"
                                    v-model="filename"
                                    label="Save Template As"
                                    hint="You must use only letters, numbers, spaces, underscores and dashes"
                                    :rules="[rules.filename]"
                                    persistent-hint
                                    clearable
                                ></v-text-field>
                            </div>

                            <div class="text__align-center layout__margin__top-50 layout__padding__bottom-10px">
                                <el-button v-if="saveOrBackButton === 'back'" class="button__base layout__width-150px button-teal layout__cursor-pointer layout__float-left layout__margin__left-10 layout__margin__top-minus-20"
                                        v-on:click="gotoStep('select-design')">Don't Save
                                </el-button>
                                <el-button v-if="saveOrBackButton === 'save'" class="button__base layout__width-150px button-teal layout__cursor-pointer layout__float-left layout__margin__left-10 layout__margin__top-minus-20"
                                        v-on:click="showSaveTemplate = false">Cancel
                                </el-button>

                                <el-button class="button__background-red button__base layout__width-150px layout__float-right layout__margin__right-10 layout__margin__top-minus-20" :disabled="saveDisabled"
                                            v-on:click="saveTemplate()">Save
                                </el-button>
                            </div>
                        </el-dialog>
                    </div>

                    <v-overlay :value="loading">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>

                </div>
            </v-flex>
        </v-layout>
    </v-main>
</template>

<script>
    import Router from '../../router.js';
    import Editor from '../../mixins/Editor.js';
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';

    export default {
        name: 'InstantMarketingDesign',
        components: {
        },
        mixins: [axios],
        data: () => ({
            valid: true,
            model: null,
            loading: false,
            product: {},
            config: {},
            proofImageUrls: [],
            editor: null,
            currProd: null,
            noOfPages: 0,
            dialog: false,
            filename: null,
            formHasErrors: false,
            pageNumber: 'Page 1',
            canvasAuthToken: '',
            saveOrBackButton: '',
            btnFirst: 0,
            btnPrev: 0,
            btnNext: 1,
            btnLast: 1,
            showSaveTemplate: false,
            saveTemplateSuccess: false,
            saveTemplateFailure: false,
            customersCanvasApiKey: `${process.env.VUE_APP_CUSTOMERS_CANVAS_API_KEY}`,
            rules: {
                required: value => !!value || 'Required.',
                filename: value => {
                    const pattern = /^[A-Za-z0-9 _-]+$/
                    return pattern.test(value) || 'Invalid filename. You must use only letters, numbers, spaces, underscores and dashes.'
                }
            }
        }),
        watch: {},
        computed: {
            //form() {
            //    return {
            //        filename: this.filename
            //    }
            //},
            saveDisabled() {
                return (this.filename == '' || this.filename == null);
            },
            cmdFirst_class() {
                return {
                    'pageNavDisabled': this.btnFirst == 0 ? true : false,
                }
            },
            cmdPrev_class() {
                return {
                    'pageNavDisabled': this.btnPrev == 0 ? true : false,
                }
            },
            cmdNext_class() {
                return {
                    'pageNavDisabled': this.btnNext == 0 ? true : false,
                }
            },
            cmdLast_class() {
                return {
                    'pageNavDisabled': this.btnLast == 0 ? true : false,
                }
            }
        },
        created() {
            var _this = this;

            window.sessionStorage.removeItem('imageUrl');

            if (document.getElementById("CcIframeApiScript")) {
                var element = document.getElementById("CcIframeApiScript");
                element.parentNode.removeChild(element);
            }

            if (!document.getElementById("CcIframeApiScript")) {
                let recaptchaScript = document.createElement('script');
                recaptchaScript.onload = async function () {
                    let productThemes = {};

                    var customer = JSON.parse(window.sessionStorage.getItem('customer')),
                        user = JSON.parse(window.sessionStorage.getItem('user')),
                        template = JSON.parse(window.sessionStorage.getItem('_template')),
                        mockupFile = window.sessionStorage.getItem('_mockupFile'),
                        priceCodes = window.sessionStorage.getItem('_priceCodes'),
                        loadGenericTemplate = window.sessionStorage.getItem('_loadGenericTemplate'),
                        templatingValues = {};

                    console.log('mockupFile=' + mockupFile);
                    console.log('priceCodes=' + priceCodes);

                    if (window.sessionStorage.getItem('templatingValues') !== "undefined") {
                        templatingValues = JSON.parse(window.sessionStorage.getItem('templatingValues'));
                    } else {
                        templatingValues = {
                            "varCompany_Colour_1": "", 
                            "varCompany_Colour_2": "", 
                            "varCompany_Colour_3": "", 
                            "varUser_Company_Name": "",
                            "varUser_Company_Brand": "", 
                            "varUser_Address_1": "", 
                            "varUser_Address_2": "", 
                            "varUser_Town": "",
                            "varUser_County": "", 
                            "varUser_PostCode": "", 
                            "varUser_FullAddress": "", 
                            "varUser_Branch_Name": "",
                            "varUser_Telephone": "", 
                            "varUser_Email": "", 
                            "varUser_Web_Address": "", 
                            "varCompany_Logo_1": null,
                            "varCompany_Logo_2": null, 
                            "varCompany_Logo_3": null, 
                            "varCompany_Logo_4": null, 
                        };
                    }

                    // if (loadGenericTemplate !== null && typeof loadGenericTemplate !== 'undefined') {
                        productThemes = {
                            [customer.ref]: {
                                "varCompany_Colour_1": _this.cmykToHex(templatingValues.varCompany_Colour_1),
                                "varCompany_Colour_2": _this.cmykToHex(templatingValues.varCompany_Colour_2),
                                "varCompany_Colour_3": _this.cmykToHex(templatingValues.varCompany_Colour_3)
                            }
                        }
                    // } else {
                    //     productThemes = {
                    //         [customer.ref]: {
                    //             "varCompany_Colour_1": "",
                    //             "varCompany_Colour_2": "",
                    //             "varCompany_Colour_3": ""
                    //         }
                    //     }
                    // };

                    console.log('productThemes=' + JSON.stringify(productThemes));
                    console.log('loadGenericTemplate=' + loadGenericTemplate);

                    var companyLogos = {};
                    // if (loadGenericTemplate !== null && typeof loadGenericTemplate !== 'undefined') {
                        companyLogos = {
                            "varCompany_Logo_1": templatingValues.varCompany_Logo_1,
                            "varCompany_Logo_2": templatingValues.varCompany_Logo_2,
                            "varCompany_Logo_3": templatingValues.varCompany_Logo_3,
                            "varCompany_Logo_4": templatingValues.varCompany_Logo_4,
                            "varCompany_Colour_1": _this.cmykToHex(templatingValues.varCompany_Colour_1),
                            "varCompany_Colour_2": _this.cmykToHex(templatingValues.varCompany_Colour_2),
                            "varCompany_Colour_3": _this.cmykToHex(templatingValues.varCompany_Colour_3)
                        }
                    // } else {
                    //     companyLogos = {
                    //         "varCompany_Logo_1": null,
                    //         "varCompany_Logo_2": null,
                    //         "varCompany_Logo_3": null,
                    //         "varCompany_Logo_4": null,
                    //         "varCompany_Colour_1": "",
                    //         "varCompany_Colour_2": "",
                    //         "varCompany_Colour_3": ""
                    //     }
                    // }

                    console.log(companyLogos);
                    window.sessionStorage.removeItem('_loadGenericTemplate');

                    if (customer.ref !== null) {
                        var endpoint = `https://cc.ravensworth.uk/api/Auth/Users/` + customer.ref + '/Tokens?seconds=3600&updateOnCall=True';
                        console.log(endpoint);

                        await Axios({
                            method: 'post',
                            url: endpoint,
                            headers: {"X-CustomersCanvasAPIKey": _this.customersCanvasApiKey}
                        })
                            .then(response => {
                                console.log(response);

                                this.canvasAuthToken = response.data.tokenId;
                            })
                            .catch(error => {
                                console.log(error);
                            })

                        this.product = {
                            "surfaces": {
                                "file": template.url,
                                "name": "Page {0}"
                            }
                        };

                        var userInfo = '';

                        if (window.sessionStorage.getItem('stateId') === null) {
                            userInfo = {
                                "varCompany_Logo_1": companyLogos.varCompany_Logo_1,
                                "varCompany_Logo_2": companyLogos.varCompany_Logo_2,
                                "varCompany_Logo_3": companyLogos.varCompany_Logo_3,
                                "varCompany_Logo_4": companyLogos.varCompany_Logo_4,
                                "varCompany_Colour_1": companyLogos.varCompany_Colour_1,
                                "varCompany_Colour_2": companyLogos.varCompany_Colour_2,
                                "varCompany_Colour_3": companyLogos.varCompany_Colour_3,
                                "varBranch_Company_Name": templatingValues.varUser_Company_Name,
                                "varBranch_Company_Brand": templatingValues.varUser_Company_Brand,
                                "varBranch_Name": templatingValues.varUser_Branch_Name,
                                "varBranch_Email": templatingValues.varUser_Email,
                                "varBranch_Telephone": templatingValues.varUser_Telephone,
                                "varBranch_Web_Address": templatingValues.varUser_Web_Address,
                                "varBranch_Address_1": templatingValues.varUser_Address_1,
                                "varBranch_Address_2": templatingValues.varUser_Address_2,
                                "varBranch_Address_3": templatingValues.varUser_Address_3,
                                "varBranch_Town": templatingValues.varUser_Town,
                                "varBranch_County": templatingValues.varUser_County,
                                "varBranch_PostCode": templatingValues.varUser_PostCode,
                                "varBranch_FullAddress": templatingValues.varUser_FullAddress,
                                "varUser_Firstname": templatingValues.varUser_Firstname,
                                "varUser_Surname": templatingValues.varUser_Surname,
                                "varUser_FullName": templatingValues.varUser_FullName,
                                "varUser_Email": templatingValues.varUser_Email,
                                "varUser_Web_Address": templatingValues.varUser_Web_Address,
                                "varUser_Telephone": templatingValues.varUser_Telephone,
                                "varUser_Staff_Image": templatingValues.varUser_Staff_Image,
                                "varUser_Job_Title": templatingValues.varUser_Job_Title,
                                "varUser_Mobile": templatingValues.varUser_Mobile,
                                "varUser_Info_1": templatingValues.varUser_Info_1,
                                "varUser_Info_2": templatingValues.varUser_Info_2,
                                "varUser_Info_3": templatingValues.varUser_Info_3,
                                "varUser_Info_4": templatingValues.varUser_Info_4,
                                "varUser_Info_5": templatingValues.varUser_Info_5,
                                "varUser_Info_6": templatingValues.varUser_Info_6
                            }
                        }

                        this.config = {
                            "tokenId": this.canvasAuthToken,
                            "autoLoadUserInfo": true,
                            "initialMode": "SimpleOnly",
                            "customerRef": customer.ref,
                            "organisationId": 1,
                            "violationWarningsSettings": {
                                "regionViolationWarningEnabled": false,
                                "safetyLineViolationWarningEnabled": false
                            },
                            "themeConfiguration": {
                                "primaryColor": "#007F8B",
                                "logo": "data:image/svg+xml;base64,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"
                            },
                            "grid": {
                                "enabled": false
                            },
                            "canvas": {
                                "rulers": {
                                    "enabled": false
                                }
                            },
                            userInfo,
                            "widgets": {
                                "ObjectInspector": {
                                    "isHidden": true,
                                    "toggleEnabled": false
                                },
                                "TopToolbar": {
                                    "revertButtonEnabled": false
                                },
                                "BottomToolbar": {
                                    "zoomValueEnabled": true,
                                    "zoomButtonsEnabled": true,
                                    "fullWindowButtonEnabled": false,
                                    "fullScreenButtonEnabled": true,
                                    "safetyLinesCheckboxEnabled": false,
                                    "gridCheckboxEnabled": false,
                                    "snapLinesCheckboxEnabled": false,
                                    "rotateButtonEnabled": false,
                                    "surfaceSwitch": {
                                        "enabled": false
                                    }
                                }
                            },
                            "defaultAssetSelectWidget": "GalleryDialog",
                            "userId": customer.ref
                        }

                        if (loadGenericTemplate !== null && typeof loadGenericTemplate !== 'undefined') {
                            this.config.productThemes = productThemes;
                            this.config.defaultProductTheme = customer.ref;
                        }

                        console.log(this.product);
                        console.log(this.config);

                        // Customer's Canvas is loaded with this line. See the JSON objects above for params.
                        if (window.sessionStorage.getItem('stateId') === null) {
                            var templateSelected = template.url.replace('.st', '');
                            this.editor = await _this.loadEditor(document.getElementById("editorFrame"), templateSelected, this.config, templatingValues);

                            if (loadGenericTemplate !== null && typeof loadGenericTemplate !== 'undefined') {
                                this.editor.applyProductTheme(customer.ref);
                            }

                            this.editor.subscribe(CustomersCanvas.IframeApi.PostMessage.Events.OnSurfaceChanged,
                                function (args) {
                                    console.log("OnSurfaceChanged fired.");
                                    console.log(JSON.stringify(args, null, 4));
                                })

                            // Save product and save state id to session
                            this.editor.saveProduct()
                            //If the product has been successfully saved.
                                .then(function (result) {
                                    //Saving the product state info.
                                    var stateId = result.stateId;
                                    window.sessionStorage.setItem('stateId', stateId);
                                    console.log(stateId);
                                })
                                //If there was an error thrown when saving the product.
                                .catch(function (error) {
                                    console.log(error);
                                });

                        } else {
                            var stateId = window.sessionStorage.getItem('stateId');
                            console.log('stateId=' + stateId);

                            this.editor = await _this.loadEditor(document.getElementById("editorFrame"), stateId, this.config, templatingValues);

                            if (loadGenericTemplate !== null && typeof loadGenericTemplate !== 'undefined') {
                                this.editor.applyProductTheme(customer.ref);
                            }

                            this.editor.subscribe(CustomersCanvas.IframeApi.PostMessage.Events.OnSurfaceChanged,
                                function (args) {
                                    console.log("OnSurfaceChanged fired.");
                                    console.log(JSON.stringify(args, null, 4));
                                })
                        }

                        Editor['data'].editor = this.editor;

                        if (mockupFile !== null) {
                            this.editor.getProduct()
                                .then(function (product) {
                                    var surface = product.surfaces.length - 1;

                                    product.setMockups([
                                    {
                                        "surface": product.surfaces[surface],
                                        "mockup": { "down": mockupFile },
                                    }
                                    ])
                                    .then(function (product) {
                                        console.log("Mockups are successfully set for the product " + product.id);
                                    })
                                    .catch(function (error) {
                                        console.error("Failed to set up the mockups: ", error);
                                    });                                        
                                });
                        }

                        this.editor.getProduct()
                            .then(function (product) {
                                // Getting the current surface index.
                                const indexOfCurrentSurface = product.surfaces.lastIndexOf(product.currentSurface);
                                console.log("The product contains " + product.surfaces.length + " page(s)");

                                // Show page navigation
                                _this.noOfPages = product.surfaces.length;
                                _this.pageNumber = "Page " + (indexOfCurrentSurface + 1) + " of " + product.surfaces.length;
                                document.getElementById("pageNavigation").classList.remove("layout__display-none");

                                // Disable first and prev buttons at start (and next and last buttons if 1 page proof)
                                _this.btnFirst = 0;
                                _this.btnPrev = 0;
                                if (product.surfaces.length == 1) {
                                    _this.btnNext = 0;
                                    _this.btnLast = 0;
                                }
                            })
                            .then(function (result) {
                                console.log("Surface switched");
                            })
                            .catch(function (error) {
                                console.error("Switching the surfaces failed with exception: ", error);
                            });
                    };
                };
                recaptchaScript.setAttribute('src', `${process.env.VUE_APP_CANVASURL}/Resources/Generated/IframeApi.js`);
                recaptchaScript.async = true;
                recaptchaScript.id = "CcIframeApiScript";
                document.head.appendChild(recaptchaScript);
            }
        },
        mounted() {
            parent.postMessage('ScrollIntoView', '*');
        },
        methods: {
            navigate(path) {
                Router.push({
                    path: '/' + path
                });
            },
            clickFirst() {
                console.log('clickFirst');
                var _this = this;

                Editor['data'].editor.getProduct()
                    .then(function (product) {
                        // Getting the current surface index.
                        const indexOfCurrentSurface = product.surfaces.lastIndexOf(product.currentSurface);
                        let indexOfPrevSurface = 0;

                        // Switching to the next surface.
                        return product.switchTo(product.surfaces[indexOfPrevSurface]);
                    })
                    .then(function (result) {
                        let indexOfCurrentSurface = result.currentSurfaceIndex + 1;

                        _this.btnFirst = 0;
                        _this.btnPrev = 0;
                        _this.btnNext = 1;
                        _this.btnLast = 1;

                        _this.pageNumber = 'Page ' + indexOfCurrentSurface + " of " + _this.noOfPages;
                        console.log('Surface switched');
                    })
                    .catch(function (error) {
                        console.error('Switching the surfaces failed with exception: ', error);
                    });
            },
            clickPrev() {
                console.log('clickPrev');
                var _this = this;

                Editor['data'].editor.getProduct()
                    .then(function (product) {
                        // Getting the current surface index.
                        const indexOfCurrentSurface = product.surfaces.lastIndexOf(product.currentSurface);

                        let indexOfPrevSurface = indexOfCurrentSurface - 1;
                        if (indexOfPrevSurface < 0)
                            indexOfPrevSurface = 0;

                        // Switching to the next surface.
                        return product.switchTo(product.surfaces[indexOfPrevSurface]);
                    })
                    .then(function (result) {
                        let indexOfCurrentSurface = result.currentSurfaceIndex + 1;

                        if (indexOfCurrentSurface == 1) {
                            _this.btnFirst = 0;
                            _this.btnPrev = 0;
                        } else {
                            _this.btnFirst = 1;
                            _this.btnPrev = 1;
                        }
                        _this.btnNext = 1;
                        _this.btnLast = 1;

                        _this.pageNumber = 'Page ' + indexOfCurrentSurface + " of " + _this.noOfPages;
                        console.log('Surface switched');
                    })
                    .catch(function (error) {
                        console.error('Switching the surfaces failed with exception: ', error);
                    });
            },
            clickNext() {
                console.log('clickNext');
                var _this = this;

                Editor['data'].editor.getProduct()
                    .then(function (product) {
                        // Getting the current surface index.
                        const indexOfCurrentSurface = product.surfaces.lastIndexOf(product.currentSurface);

                        let indexOfNextSurface = indexOfCurrentSurface + 1;
                        if (indexOfNextSurface > (product.surfaces.length - 1))
                            indexOfNextSurface = product.surfaces.length - 1;

                        // Switching to the next surface.
                        return product.switchTo(product.surfaces[indexOfNextSurface]);
                    })
                    .then(function (result) {
                        let indexOfCurrentSurface = result.currentSurfaceIndex + 1;

                        if (indexOfCurrentSurface == _this.noOfPages) {
                            _this.btnNext = 0;
                            _this.btnLast = 0;
                        } else {
                            _this.btnNext = 1;
                            _this.btnLast = 1;
                        }
                        _this.btnFirst = 1;
                        _this.btnPrev = 1;

                        _this.pageNumber = 'Page ' + indexOfCurrentSurface + " of " + _this.noOfPages;
                        console.log('Surface switched');
                    })
                    .catch(function (error) {
                        console.error('Switching the surfaces failed with exception: ', error);
                    });
            },
            clickLast() {
                console.log('clickLast');
                var _this = this;

                Editor['data'].editor.getProduct()
                    .then(function (product) {
                        // Getting the current surface index.
                        const indexOfCurrentSurface = product.surfaces.lastIndexOf(product.currentSurface);
                        let indexOfPrevSurface = product.surfaces.length - 1;

                        // Switching to the next surface.
                        return product.switchTo(product.surfaces[indexOfPrevSurface]);
                    })
                    .then(function (result) {
                        let indexOfCurrentSurface = result.currentSurfaceIndex + 1;

                        _this.btnFirst = 1;
                        _this.btnPrev = 1;
                        _this.btnNext = 0;
                        _this.btnLast = 0;

                        _this.pageNumber = 'Page ' + indexOfCurrentSurface + " of " + _this.noOfPages;
                        console.log('Surface switched');
                    })
                    .catch(function (error) {
                        console.error('Switching the surfaces failed with exception: ', error);
                    });
            },
            showSaveTemplateDialog(action) {
                console.log('showSaveTemplateDialog: ' + action);

                this.saveOrBackButton = action;
                this.showSaveTemplate = true;
            },
            gotoStep(destination) {
                console.log('gotoStep: ' + destination);

                var _this = this,
                    stateId = window.sessionStorage.getItem('stateId');

                console.log('stateId=' + stateId);

                if (destination == 'select-design') {
                    if (destination != '') {
                        _this.navigate(destination);
                    }
                } else {
                    Editor['data'].editor.saveProduct(stateId)
                    //If the product has been successfully saved.
                        .then(function (result) {
                            //Saving the product state info.
                            var stateId = result.stateId;
                            window.sessionStorage.setItem('stateId', stateId);
                            console.log(stateId);

                            _this.removeCanvasAuthToken(_this.canvasAuthToken);

                            if (destination != '') {
                                _this.navigate(destination);
                            }
                        })
                        //If there was an error thrown when saving the product.
                        .catch(function (error) {
                            console.log(error);
                        });
                }

                this.dialog = false;
            },
            async saveTemplate() {
                console.log('saveTemplate: ' + this.filename);

                if (this.filename == '' || this.filename == null) {
                    console.log('no filename entered');
                }

                this.loading = true;

                var stateId = window.sessionStorage.getItem('stateId'),
                    customer = JSON.parse(window.sessionStorage.getItem('customer')),
                    template = JSON.parse(window.sessionStorage.getItem('_template')),
                    endpoint = `${process.env.VUE_APP_CANVASURL}/api/users/` + customer.ref + '/states/' + this.filename.replace(/ /g, '_'),
                    _this = this;

                // The product needs to be saved twice to address an issue where template changes in the CC editor were not being
                // saved to the template the first time but were being saved the second time.
                await Editor['data'].editor.saveProduct(stateId)
                //If the product has been successfully saved.
                    .then(async function (result) {
                        console.log(result);

                        await Editor['data'].editor.saveProduct(stateId)
                        //If the product has been successfully saved.
                            .then(async function (result) {
                                //Saving the product state info.
                                console.log(result);

                                console.log(endpoint);
                                console.log('customersCanvasApiKey=' + _this.customersCanvasApiKey);

                                const parameters = {
                                    "CopyFrom": {
                                        "UserId": customer.ref,
                                        "StateId": stateId
                                    },
                                    "Overwrite": true
                                };

                                console.log(parameters);

                                const headers = {
                                    "X-CustomersCanvasAPIKey": _this.customersCanvasApiKey,
                                    "Content-Type": "application/json"
                                }

                                console.log(headers);

                                await Axios({
                                        method: 'post',
                                        url: endpoint,
                                        headers: headers, 
                                        data: JSON.stringify(parameters)
                                    })
                                    .then(async response => {
                                        console.log(response);

                                        endpoint = `${process.env.VUE_APP_TKGATEWAY}/api/services/app/Artwork/FindArtworkTemplates`;
                                        console.log(endpoint);

                                        await Axios.get(endpoint, _this.returnHeaderUsingToken())
                                            .then(async response => {
                                                console.log(response);

                                                var templates = response.data.result;

                                                var filtered = templates.filter(function(item){
                                                    return item.customerRef == customer.ref && item.name == _this.filename;
                                                });

                                                if (filtered.length > 0) {
                                                    filtered.forEach(async template => {
                                                        endpoint = `${process.env.VUE_APP_EXTERNAL_ACCOUNTS}/api/services/app/Artwork/DeleteArtworkTemplate?id=` + template.id;
                                                        console.log(endpoint);

                                                        await Axios.delete(endpoint, _this.returnHeaderUsingToken())
                                                            .then(response => {
                                                                console.log(response);
                                                            })
                                                            .catch(error => {
                                                                console.log(error);
                                                            })
                                                    })
                                                }
                                            })
                                            .catch(error => {
                                                console.log(error);
                                            })

                                        Editor['data'].editor.getProofImages({maxHeight: 300, maxWidth: 300})
                                            // If the links to proof images were generated successfully.
                                            .then(function (result) {
                                                _this.proofImageUrls = result.proofImageUrls;
                                                
                                                console.log(_this.proofImageUrls[0][0]);

                                                const templateDetails = {
                                                    "name": _this.filename,
                                                    "masterUrl": _this.filename.replace(/ /g, '_') + '.st',
                                                    "customerRef": customer.ref,
                                                    "fCode": template.fCode,
                                                    "thumbUrl": _this.proofImageUrls[0][0] + '||' + _this.proofImageUrls[1][0],
                                                    "saved": _this.getNow(),
                                                    "isActive": true,
                                                    "folder": template.folder,
                                                    "isGeneric": false,
                                                    "TestDataJson": template.jsonData,
                                                    "pageCount": template.pageCount,
                                                    "pageHeight": template.pageHeight,
                                                    "pageWidth": template.pageWidth,
                                                    "userId": customer.id
                                                }

                                                console.log('templateDetails: ' + JSON.stringify(templateDetails));

                                                endpoint = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Artwork/AddArtworkTemplate`;

                                                Axios.post(endpoint, templateDetails, _this.returnHeaderUsingToken())
                                                    .then(response => {
                                                        console.log(response);

                                                        _this.loading = false;
                                                        _this.saveTemplateSuccess = true;
                                                        _this.showSaveTemplate = false;

                                                        if (_this.saveOrBackButton == 'back') {
                                                            _this.gotoStep('select-design')
                                                        }
                                                    })
                                                    .catch(error => {
                                                        console.log(error);

                                                        _this.loading = false;
                                                        _this.saveTemplateFailure = true;
                                                    })
                                            })
                                            // If there was an error thrown while getting links to proof images.
                                            .catch(function (error) {
                                                console.log(error);

                                                _this.loading = false;
                                                _this.saveTemplateFailure = true;
                                            });
                                    })
                                    .catch(error => {
                                        console.log(error)

                                        _this.loading = false;
                                        _this.saveTemplateFailure = true;
                                    })
                            })
                            //If there was an error thrown when saving the product.
                            .catch(function (error) {
                                console.log(error)

                                _this.loading = false;
                                _this.saveTemplateFailure = true;
                            });
                        })
                //If there was an error thrown when saving the product.
                .catch(function (error) {
                    console.log(error)

                    _this.loading = false;
                    _this.saveTemplateFailure = true;
                });
            },
            async loadEditor(editorFrame, product, config, templatingValues) {
                var editor = await CustomersCanvas.IframeApi.loadEditor(editorFrame, product, config);

                this.currProd = await editor.getProduct();
                let productModel = await this.currProd.getProductModel();

                productModel.getAllItems().filter(item => item.type === "BoundedTextItem").forEach(textItem => {
                    if (textItem.text.indexOf('[[') > -1) {
                        var itemText = textItem.text,
                            reg = /[[[a-zA-Z0-9_]*]]/g,
                            result;

                        // Loop round interpolated placeholders replacing with relevant text from templatingValues
                        while ((result = reg.exec(itemText)) !== null) {
                            var userVar = result[0].replace('[[', '').replace(']]', '');
                            itemText = itemText.replace(result[0], templatingValues[userVar]);
                        }

                        textItem.text = itemText;
                        console.log('textItem.text=' + textItem.text);
                        console.log('textItem.originalText=' + textItem.originalText);
                    }
                });

                this.currProd.setProductModel(productModel);
                return editor;
            },
            async removeCanvasAuthToken(token) {
                var endpoint = `https://cc.ravensworth.uk/api/Auth/Tokens/` + token;

                await Axios({
                    method: 'delete',
                    url: endpoint,
                    headers: {"X-CustomersCanvasAPIKey": this.customersCanvasApiKey}
                })
                    .then(response => {
                        console.log(response);
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            getNow: function() {
                const today = new Date();
                const date = today.getFullYear() + '-' + this.pad2(today.getMonth() + 1) + '-' + this.pad2(today.getDate());
                const time = this.pad2(today.getHours()) + ":" + this.pad2(today.getMinutes()) + ":" + this.pad2(today.getSeconds()) + "." + this.pad3(today.getMilliseconds());
                const dateTime = date + 'T' + time + 'Z';
                
                return dateTime;
            },
            pad2: function (value) {
                return ('00' + value).slice(-2);
            },
            pad3: function (value) {
                return ('000' + value).slice(-3);
            },
            cmykToHex: function(value) {
                if (value === undefined) {
                    return '';
                } else  {
                    if (value.substring(0, 4) !== 'cmyk') {
                        return value;
                    } else {
                        var cmyk = value.replace('cmyk(', '').replace(')', '').replace(/ /g, '').replace(/%/g, '');

                        var cmykArray = cmyk.split(','),
                            c = cmykArray[0] / 100,
                            m = cmykArray[1] / 100,
                            y = cmykArray[2] / 100,
                            k = cmykArray[3] / 100,
                            cyan = (c * 255 * (1 - k)) << 16,
                            magenta = (m * 255 * (1 - k)) << 8,
                            yellow = (y * 255 * (1 - k)) >> 0,
                            black = 255 * (1 - k),
                            white = black | black << 8 | black << 16,
                            color = white - (cyan | magenta | yellow );

                        return ('#' + this.padZero(color.toString(16)));
                    }
                }
            },
            padZero: function(value) {
                return "000000".substr(value.length) + value;
            }
        }
    };
</script>
